'use client';

import { ImageComponent } from '../Image';

import { ScPreloaderContainer, ScPreloaderMain } from './styled';

export const Preloader = () => (
  <ScPreloaderMain>
    <ScPreloaderContainer>
      <ImageComponent
        alt="preloader"
        aria-label="Level Up"
        height={200}
        priority
        src="/preloader/preloader.svg?url"
        width={200}
      />
    </ScPreloaderContainer>
  </ScPreloaderMain>
);
